import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createGlobalStyle } from 'styled-components';
import { HrFont } from '@components/styles/hr-styles';
import i18n from '../i18n';
import ContextStoreProvider from './store/store-provider';
import { PostulantFormRoutes } from './views';
import DisplaySettingsProvider from './store/display-settings';

const GlobalStyle = createGlobalStyle`
  p {
    font-family: ${HrFont};
  }
`;

const queryClient = new QueryClient();

function PostulationForm({ reCaptcha, cloudflareRecaptcha, drive, clientAppDrive }) {
  ReactDOM.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n} key='translate'>
          <ContextStoreProvider key='recaptcha' data={{ drive, clientAppDrive }}>
            {cloudflareRecaptcha ? (
              // Si existe cloudflareRecaptcha, no renderizamos GoogleReCaptchaProvider
              <>
                <GlobalStyle />
                <DisplaySettingsProvider>
                  <PostulantFormRoutes
                    key='crud-postulant'
                    cloudflareRecaptcha={cloudflareRecaptcha}
                  />
                </DisplaySettingsProvider>
              </>
            ) : (
              // Si no existe cloudflareRecaptcha, renderizamos GoogleReCaptchaProvider
              <GoogleReCaptchaProvider
                useRecaptchaNet
                useEnterprise='true'
                reCaptchaKey={reCaptcha}
                scriptProps={{ async: true, defer: true, appendTo: 'body' }}
              >
                <GlobalStyle />
                <DisplaySettingsProvider>
                  <PostulantFormRoutes key='crud-postulant' />
                </DisplaySettingsProvider>
              </GoogleReCaptchaProvider>
            )}
          </ContextStoreProvider>
        </I18nextProvider>
      </QueryClientProvider>
    </StrictMode>,
    document.getElementById('app')
  );
}

export default PostulationForm;
